import { call, put, takeEvery } from "redux-saga/effects";

// new Password Redux States
import { VERIFY_ACCESS_TOKEN, VERIFY_MAIL } from "./actionTypes";
import {
  verifyAccessTokenFailed,
  verifyMailFailed,
  verifyMailSuccessful
} from "./actions";
//Include Both Helper File with needed methods
import { verifyNewMail } from "../../../helpers/fakebackend_helper";
//restapi end point
import { CANDIDATE, ORGANIZATION, RECRUITER } from "../../../common/constant/LoginEnum";
import * as constClass from "../../../common/constant/constantURL";

function* verifyMail({ payload: { user } }) {
  try {
    const myKey = "code";
    const myObject = {
      [myKey]: user.id,
      module: user.module,
    };
    let url;
  
    if (user.module === CANDIDATE) {
      url = constClass.REST_API_VERIFY_MAIL_URL + "/candidate";
    } else if (user.module === ORGANIZATION) {
      url = constClass.REST_API_VERIFY_MAIL_URL + "/organization";
    }else if (user.module === RECRUITER) {
      url = constClass.REST_API_VERIFY_MAIL_URL + "/recruiter";
    }
    const response = yield call(verifyNewMail, url, myObject);
    yield put(verifyMailSuccessful(response));
  } catch (error) {
    yield put(verifyMailFailed(error.split("#")));
    localStorage.setItem("isAuthProtected", false);
    localStorage.removeItem("setpassword");
    localStorage.removeItem("authUser");
  }
}

function* verifyAccessToken({ payload: { token } }) {
  try {
    // let url =
    //   constClass.REST_API_VERIFY_ACCESS_TOKEN;
   // const response = yield call(getCall, url);
   // yield put(verifyAccessTokenSuccessful(response));
  } catch (error) {
    yield put(verifyAccessTokenFailed(error));
  }
}

function* mailSaga() {
  yield takeEvery(VERIFY_MAIL, verifyMail);
  yield takeEvery(VERIFY_ACCESS_TOKEN, verifyAccessToken);
}

export default mailSaga;
